module.exports = __webpack_public_path__ + "media/images/malvinas/Iso_1-f322bbe05c4b8e02123f55dab7d7e05c.svg";